import React from 'react';
import classNames from 'classnames';

// @ts-ignore TS(2322): Type 'null' is not assignable to type 'string'.
function Menu({ className = null, children, ...otherProps }) {
  const menuClass = classNames('ws-menu', className);

  return (
    <ul className={menuClass} {...otherProps}>
      {children}
    </ul>
  );
}

export default Menu;
